import { render, staticRenderFns } from "./Myscorecard.vue?vue&type=template&id=0c44929b&scoped=true&"
import script from "./Myscorecard.vue?vue&type=script&lang=js&"
export * from "./Myscorecard.vue?vue&type=script&lang=js&"
import style0 from "./Myscorecard.vue?vue&type=style&index=0&id=0c44929b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c44929b",
  null
  
)

export default component.exports